export function findFirstFocusableElement(container: HTMLElement): HTMLElement | null {
  const focusableElements = collectFocusableElements(container);
  const firstElement = focusableElements[0];
  if (firstElement === undefined) {
    return null;
  }
  return firstElement;
}

function collectFocusableElements(container: HTMLElement): HTMLElement[] {
  const focusableElements = container.querySelectorAll<HTMLElement>(
    'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
  );
  return Array.from(focusableElements);
}

export function trapFocusWithinOverlay(overlay: HTMLElement | null, keyboardEvent: KeyboardEvent) {
  if (overlay === null) {
    return;
  }
  const focusableElements = collectFocusableElements(overlay);
  const firstElement = focusableElements[0];
  const lastElement = focusableElements[focusableElements.length - 1];
  if (firstElement === undefined || lastElement === undefined) {
    keyboardEvent.preventDefault();
    overlay.focus();
    return;
  }
  const activeElement = document.activeElement;
  if (keyboardEvent.shiftKey === true && activeElement === firstElement) {
    keyboardEvent.preventDefault();
    lastElement.focus();
    return;
  }
  if (keyboardEvent.shiftKey === false && activeElement === lastElement) {
    keyboardEvent.preventDefault();
    firstElement.focus();
  }
}
